import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import SiteHeader from 'views/site/layout/header/site-header';
import SiteContent from 'views/site/layout/content/site-content';
import OfflineNotice from 'components/Offline';
import GlobalValidationBlockDialog from 'components/ValidationBlockDialog/GlobalValidationBlockDialog';

const mapStateToProps = state => ({
  toggle: state.site.menu
});

const SiteLayout = ({ children, toggle }) => (
  <div className={classNames('bhp-container', { toggle })}>
    <SiteHeader />
    <SiteContent>
      {children}
    </SiteContent>
    <OfflineNotice />
    <GlobalValidationBlockDialog />
  </div>
);

SiteLayout.propTypes = {
  children: PropTypes.any,
  toggle: PropTypes.bool.isRequired
};

SiteLayout.defaultProps = {
  children: null
};

export default withRouter(connect(mapStateToProps, null)(SiteLayout));
